import Vue from 'vue';
// @ts-ignore
import '@/business/composition-api';
import App from './App.vue';
import { routerInit } from './router';
import store from './store';
import { install as i18nPlugin } from '@/i18n';
import { rem, vueTap, initReport, request, CustomException } from '@tencent/ppd-base-libs';
import { axios } from '@tencent/wphk-base-request';
import { setTiming } from '@/business/performance';
import { setServerTime } from '@tencent/wphk-components-common/utils/server-time';
import { setRequest } from '@tencent/wphk-act-base-cgi';
import mtaGlobalConfig from '@/mta-config-global';
import { plugin } from '@tencent/fit-bi-sdk';
import { aegis } from '@tencent/wphk-base-report';
import { loginInit } from '@/utils/login';
import { to, handleBigFont } from '@tencent/wphk-base-utils';

// 处理大字体闪动
handleBigFont();

/** 初始化ABT */
async function initAbtInfo() {
  // 在初始化ABT之前，需要登陆信息
  await loginInit();
}

/** 将所有初始化逻辑包裹到init函数里，是为了在路由生效前完成ABT初始化 */
async function init() {
  request.init(axios);

  setRequest(request);
  const [err] = await to(initAbtInfo());
  if (err) {
    new CustomException(err, 'InitAbtInfoFail', '初始化abt信息失败');
  }

  const router = routerInit();
  Vue.use(plugin, { // 用到mtaGlobalConf里的cid/sid/group/project/projectDesc属性
    ...mtaGlobalConfig,
    route: router,
  });

  // 打点 main.ts 时间
  setTiming('main');
  // 设置服务器时间
  setServerTime(window.__$$_serverTimeMills || Date.now());

  // 测速上报
  aegis.init({ id: process.env.VUE_APP_PKGNAME });

  initReport({
    router,
    appEnv: process.env.VUE_APP_ENV,
    business: process.env.VUE_APP_PKGNAME,  // 区分业务，用于elk
    isReportPageStayedTime: true, // 是否上报页面停留时间
    sentry: {
      dsn: 'https://040aa22c16374acc80e75e8464b652a1@report.url.cn/sentry/1922',
      // webpack变异全局变量
      release: process.env.VUE_APP_SENTRY_VERSION,
    },
    bi: {
      reportNeedLogin: true,
    },
    appVersion: process.env.VUE_APP_SENTRY_VERSION,
  }, Vue);
  // 开启rem布局
  rem();
  // 开启vtap
  Vue.use(vueTap);
  Vue.use(i18nPlugin);
  Vue.config.productionTip = false;
  Vue.config.ignoredElements = ['wx-open-launch-weapp', 'wx-open-subscribe'];

  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');

  aegis.reportTime('main_ready');
}
init();


